import SectionHeading from "./SectionHeading";
import { channels } from "@/mocks/home";

export default function Channels() {
  return (
    <section id="channels" className="bg-background-100 scroll-mt-20">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-start lg:justify-between">
          <div className="w-full lg:max-w-md">
            <SectionHeading
              eyebrow="Channels"
              title="话题分区 · 按兴趣看讨论"
              description="把热点归到清晰的板块里，想只看某一类事件时，不必在信息流里大海捞针。"
            />
            <div className="mt-6 flex flex-wrap gap-2">
              {["影视综", "消费观察", "直播电商", "社区热议", "品牌公关", "数码体验"].map(
                (tag, index) => (
                  <a
                    key={tag}
                    href="#topics"
                    className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs transition-colors ${
                      index % 3 === 0
                        ? "bg-primary-100 text-primary-700 hover:bg-primary-200"
                        : index % 3 === 1
                          ? "bg-accent-100 text-accent-900 hover:bg-accent-200"
                          : "bg-secondary-100 text-secondary-900 hover:bg-secondary-200"
                    }`}
                  >
                    #{tag}
                  </a>
                ),
              )}
            </div>
          </div>

          <div className="grid w-full grid-cols-2 gap-4 sm:grid-cols-3 lg:max-w-2xl lg:grid-cols-4">
            {channels.map((channel) => (
              <a
                key={channel.name}
                href="#topics"
                className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-200 text-foreground-700">
                  <i className={`${channel.icon} text-lg`} />
                </span>
                <span className="mt-3 text-sm font-medium text-foreground-900">
                  {channel.name}
                </span>
                <span className="mt-1 text-xs text-foreground-500">{channel.count} 个在榜话题</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}